import { render, staticRenderFns } from "./common-alert.vue?vue&type=template&id=7350d3d4&scoped=true"
import script from "./common-alert.vue?vue&type=script&lang=ts"
export * from "./common-alert.vue?vue&type=script&lang=ts"
import style0 from "./common-alert.vue?vue&type=style&index=0&id=7350d3d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7350d3d4",
  null
  
)

export default component.exports